import { AddContactFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddContactFormModalContext = () => {
  const context = useContext(AddContactFormModalContext);

  if (!context) throw new Error('AddContactFormModalContext has to be wrapped by AddContactFormModalContextProvider component')

  return context
}
